/**
 * Download data as a JSON file.
 * @param {string} filename
 * @param {any} data - Any JSON-serializable value
 */
export function exportJsonFile(filename, data) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Read a File object and parse its contents as JSON.
 * @param {File} file
 * @returns {Promise<any>} Resolves with parsed JSON; rejects on read/parse error.
 */
export function importJsonFile(file) {
  return file.text().then(JSON.parse);
}
